class ProductInfoTabs extends HTMLElement {
	constructor() {
		super();
		this.tabButtons = this.querySelectorAll('button')
		this.bindEvents();
	}

	bindEvents() {
		this.tabButtons.forEach((tab) =>
			tab.addEventListener('click', this.onTabClick.bind(this))
		);
	}

	onTabClick(e) {
		e.preventDefault();

		this.tabButtons.forEach((tab, i) => {
			if (tab == e.currentTarget) {
				this.tabButtons[i].classList.toggle('active')
			} else {
				this.tabButtons[i].classList.remove('active')
			}
		})
	}
  }

  customElements.define("product-info-tabs", ProductInfoTabs);
